import { useEffect } from "react";
import { useCopilotChatConfiguration } from "@copilotkit/react-core/v2";

/** Single source for the sidebar width: the CopilotSidebar prop and the dialog-shift CSS both read it. */
export const COPILOT_SIDEBAR_WIDTH = "clamp(420px, 30vw, 720px)";

/**
 * Marks `<html data-copilot-open>` while the chat sidebar is open and exposes its width as
 * `--copilot-sidebar-w`, so centered dialogs can re-center in the space left of the panel
 * (see index.css) instead of sliding under it.
 *
 * Must be called inside the sidebar's own chat-config provider (its header slot): only that
 * provider's `isModalOpen` tracks the close button — the outer one only pushes opens down.
 */
export function useCopilotSidebarOpenMarker() {
  const isOpen = useCopilotChatConfiguration()?.isModalOpen ?? false;

  useEffect(() => {
    if (!isOpen) return;
    const root = document.documentElement;
    root.dataset.copilotOpen = "";
    root.style.setProperty("--copilot-sidebar-w", COPILOT_SIDEBAR_WIDTH);
    return () => {
      delete root.dataset.copilotOpen;
      root.style.removeProperty("--copilot-sidebar-w");
    };
  }, [isOpen]);
}
